import React, { useEffect, useState } from "react";

import Alert from "react-bootstrap/Alert";
import { Body } from "./style";
import { connect } from "react-redux";

const MessageHandler = ({ messages, type }) => {
  const [showMessage, setShowMessage] = useState(true);
  const [messagesToShow, setShowMessages] = useState([]);
  useEffect(() => {
    setShowMessage(true);
    setShowMessages(messages);
    setTimeout(() => {
      setShowMessage(false);
    }, 5000);
  }, [messages]);
  return (
    <Body>
      {showMessage &&
        messagesToShow &&
        messagesToShow.map(e => {
          return <Alert variant={e.type}>{e.message}</Alert>;
        })}
    </Body>
  );
};
const mapDispatchToProps = dispatch => ({});

const mapStateToProps = state => ({ messages: state.messages.messages });

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MessageHandler);
